export enum SIDEBAR_VIEWS {
    TOPICS = 'topics',
    TAGS = 'file_tags',
}

export enum SIDEBAR_TYPES {
    TOPICS_TAGS = 'topics-tags',
    REPORTS = 'reports',
}
